module.exports = __webpack_public_path__ + "img/image 1134@2x.5ecf30a3.png";